<div class="slide-toggle" [ngClass]="{'on': this.status, 'allowLight': allowLight}" (click)="toggle()">
  <!-- <div class="slide-toggle-on"></div>
  <div class="slide-toggle-off"></div> -->
  <div class="slide-toggle-shadow"></div>
  <!-- <div class="slide-toggle-border"></div> -->
</div>
